import { render, staticRenderFns } from "./MemberPermission.vue?vue&type=template&id=e52ee554&"
import script from "./MemberPermission.vue?vue&type=script&lang=js&"
export * from "./MemberPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports